import { AMEX_PROFESSIONAL_SIX_DOLLARS, AMEX_PROFESSIONAL_SIX_DOLLARS_STRIPE, AMEX_STARTER_FREE, AMEX_STARTER_FREE_STRIPE } from '@Shared/constants';
export function isAmexCompany(company) {
    if (!company) {
        return false;
    }
    return ([AMEX_STARTER_FREE, AMEX_PROFESSIONAL_SIX_DOLLARS, AMEX_STARTER_FREE_STRIPE, AMEX_PROFESSIONAL_SIX_DOLLARS_STRIPE].indexOf(company.billing_plan) !== -1);
}
export function getSignUpChannel(company) {
    var _a;
    if (isAmexCompany(company)) {
        return 'amex';
    }
    const utm_parameter = company === null || company === void 0 ? void 0 : company.utm_parameter;
    return ((_a = utm_parameter === null || utm_parameter === void 0 ? void 0 : utm_parameter.referralParameters) === null || _a === void 0 ? void 0 : _a.channel) || 'direct';
}
